(() => {
  if (window.__jhAllProductsReady) return;
  window.__jhAllProductsReady = true;

  const sizeKey = 'jh-all-products-page-size';
  const validSizes = new Set(['16', '24', '48']);
  const url = new URL(window.location.href);
  const explicitView = url.searchParams.get('view');
  const explicitSize = explicitView === 'shop-all-24' ? '24' : explicitView === 'shop-all-48' ? '48' : null;
  const read = (key) => {
    try { return window.localStorage.getItem(key); } catch { return null; }
  };
  const save = (key, value) => {
    try { window.localStorage.setItem(key, value); } catch { /* The current visit still works. */ }
  };
  // The Grid/List choice was retired on 2026-10-06; drop the stored value.
  try { window.localStorage.removeItem('jh-all-products-view'); } catch { /* Nothing stored. */ }
  const storedSize = read(sizeKey);

  if (!explicitSize && validSizes.has(storedSize) && storedSize !== '16') {
    url.searchParams.set('view', `shop-all-${storedSize}`);
    url.searchParams.delete('page');
    window.location.replace(url.href);
    return;
  }

  const currentSize = explicitSize || '16';
  save(sizeKey, currentSize);

  // The control sits in the filter bar (desktop and mobile copies), re-rendered when filters change.
  document.querySelectorAll('[data-jh-page-size]').forEach((select) => { select.value = currentSize; });

  document.addEventListener('click', (event) => {
    const pageLink = event.target.closest('.jh-all-catalog .pagination a[href]');
    if (!pageLink || currentSize === '16') return;
    const nextUrl = new URL(pageLink.href, window.location.href);
    if (nextUrl.searchParams.has('view')) return;
    nextUrl.searchParams.set('view', `shop-all-${currentSize}`);
    event.preventDefault();
    window.location.assign(nextUrl.href);
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-jh-page-size]')) return;
    const size = event.target.value;
    if (!validSizes.has(size)) return;
    save(sizeKey, size);
    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.delete('page');
    if (size === '16') nextUrl.searchParams.delete('view');
    else nextUrl.searchParams.set('view', `shop-all-${size}`);
    window.location.assign(nextUrl.href);
  });
})();
